import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'lib-ui-file-upload',
    imports: [CommonModule, TranslateModule],
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.css'
})
export class FileUploadComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;

  @Input()
  public label = "choose file";

  @Input()
  public labelClassName = "";

  /**
   * File is read as DataUrl-string (base64)
   */
  @Output()
  public fileIsRead = new EventEmitter<string>();

  protected async fileUploadChange() {
    if (this.fileInput && this.fileInput.nativeElement.files) {
      const dataUri = await this.readFileToDataUrl(this.fileInput.nativeElement.files[0]);
      if (dataUri) {
        this.fileIsRead.emit(dataUri);
      }
    }
  }

  private async readFileToDataUrl(file: File): Promise<string | null> {
    return new Promise<string | null>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(<string>reader.result);
      };
      reader.onerror = () => {
        reject();
      };
    });
  }
}
